<template>
    <div>
        <div class="com-model" style="padding-top: 28px;padding-bottom: 40px">
            <div class="main-title">企业相册</div>
            <div class="main-tip">上传优质的视频与图片更好地向外界展示企业形象，提升招聘吸引力</div>
            <div class="save primary-btn" @click="handleSave">保存</div>

            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">企业视频</div>
                    <div class="num">{{videoList.length}}/3</div>
                </div>
                <div class="padding-left">
                    <div class="video-status" v-if="videoStatus != 1 && videoList.length">
                        {{videoStatus == 0 ? '视频正在审核中，审核通过后求职者可见' : '视频未通过审核，请重新拍摄上传'}}
                    </div>
                    <video-upload :video-list="videoList"></video-upload>
                </div>
            </div>
            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">外景门头</div>
                    <div class="num">{{mainPicList.length}}/5</div>
                    <div class="tip">企业的外景门头相关照片</div>
                </div>
                <div class="padding-left img-list">
                    <image-upload :img-list="mainPicList"></image-upload>
                </div>
            </div>
            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">工作环境</div>
                    <div class="num">{{workingEnvPicList.length}}/5</div>
                    <div class="tip">企业的工作环境相关照片</div>
                </div>
                <div class="padding-left img-list">
                    <image-upload :img-list="workingEnvPicList"></image-upload>
                </div>
            </div>
            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">就餐环境</div>
                    <div class="num">{{diningEnvPicList.length}}/5</div>
                    <div class="tip">企业的就餐环境相关照片</div>
                </div>
                <div class="padding-left img-list">
                    <image-upload :img-list="diningEnvPicList"></image-upload>
                </div>
            </div>
            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">住宿环境</div>
                    <div class="num">{{accommodationEnvPicList.length}}/5</div>
                    <div class="tip">企业的住宿环境相关照片</div>
                </div>
                <div class="padding-left img-list">
                    <image-upload :img-list="accommodationEnvPicList"></image-upload>
                </div>
            </div>
            <div class="m-b-30">
                <div class="in-title flex">
                    <div class="title">其他照片</div>
                    <div class="num">{{otherPicList.length}}/5</div>
                    <div class="tip">企业的其他相关照片</div>
                </div>
                <div class="padding-left img-list">
                    <image-upload :img-list="otherPicList"></image-upload>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import ImageUpload from '../../components/ImageUpload.vue'
import VideoUpload from '../../components/VideoUpload.vue'
export default {
    name: 'album',
    data(){
        return {
            videoStatus: null,
            videoList: [],
            mainPicList: [], // 企业门头图片列表
            workingEnvPicList: [],// 工作环境图片列表
            diningEnvPicList: [],// 就餐环境图片列表
            accommodationEnvPicList: [],// 住宿环境图片列表
            otherPicList: [],// 其他图片列表
            id: null
        }
    },
    components: {
        VideoUpload,
        ImageUpload
    },
    mounted(){
        this.getData()
    },
    components: {
        VideoUpload,
        ImageUpload
    },
    methods: {
        getData () {
            this.$http.get('/wapi/company/pic/get').then(res => {
                if (res.status == 200) {
                    const data = res.data;
                    this.videoList = data.videoList;
                    this.mainPicList = data.mainPicList;
                    this.workingEnvPicList = data.workingEnvPicList;
                    this.diningEnvPicList = data.diningEnvPicList;
                    this.accommodationEnvPicList = data.accommodationEnvPicList
                    this.otherPicList = data.otherPicList
                    this.videoStatus = data.videoStatus
                    this.id = data.id
                }
            })
        },
        handleSave () {
            this.$http.post('/wapi/company/pic/modify', {
                videoList: this.videoList,
                mainPicList: this.mainPicList,
                workingEnvPicList: this.workingEnvPicList,
                diningEnvPicList: this.diningEnvPicList,
                accommodationEnvPicList: this.accommodationEnvPicList,
                otherPicList: this.otherPicList,
                id: this.id
            }).then(res => {
                if (res.status == 200) {
                    this.$message.success('保存成功')
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
@padding-left: 25px;
.com-model{
    position: relative;
    border-radius: 10px;

    .m-b-30 {
        padding-left: 24px;
    }
}
.padding-left{
    padding-left: @padding-left;
}
.save{
    position: absolute;
    top: 32px;
    right: 32px;
    width: 176px;
    height: 48px;
    line-height: 48px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
    font-weight: 500;
    color: #FFFFFF;
}
.main-title{
    height: 28px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
    font-weight: 500;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
    margin-bottom: 21px;
    padding-left: @padding-left;
}
.main-tip{
    font-size: 16px;
    font-weight: 400;
    color: #555555;
    line-height: 22px;
    margin-bottom: 60px;
    padding-left: @padding-left;
}
.video-status{
    font-size: 14px;
    margin-bottom: 20px;
    color: #FE4A6F;
}
.in-title{
    padding-left: @padding-left - 6px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC, 'Microsoft Yahei', '微软雅黑', Sans-serif;
    font-weight: 500;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
    margin-bottom:22px;
    border-left: 6px solid #057CF9 ;
    .num{
        font-size: 20px;
        font-weight: 400;
        color: #555555;
        line-height: 28px;
        margin-left: 16px;
    }
    .tip{
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        line-height: 28px;
        margin-left: 25px;
    }
}

</style>



// WEBPACK FOOTER //
// index.vue?4af39f18